import { Theme } from '@shipengine/giger-theme';
import { css } from '@emotion/react';

export function getPageTitleStyles(theme: Theme) {
    return css({
        color: theme.palette.primary.main,
        textAlign: 'center',
        width: '95%',

        [theme.mediaQuery('tablet')]: {
            width: '100%',
        },
    });
}

export function getOnboardingPageStyles() {
    return css({
        height: '100%',
    });
}

export function getOnboardingBackgroundImageStyles(theme: Theme) {
    return css({
        [theme.mediaQuery('tablet')]: {
            position: 'fixed',
            zIndex: '-1',
            top: '9vh',
            width: '100vw',
            height: '100vh',
            backgroundImage: `url('${config.cdn.url}/pro/statics/shapes/onboarding-background.png')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '89vw 75vh',
            backgroundPosition: 'center',
        },
    });
}
